import React from 'react';
import { FiShield, FiLock, FiShare2, FiClock } from 'react-icons/fi';
import { HomeBtn, HomeKicker } from './HomePrimitives';
import { HomeReveal } from './HomeMotion';

const PILLARS = [
  {
    icon: <FiShield />,
    title: 'Role-based access',
    text: 'Granular permissions ensure the right people have the right access—nothing more, nothing less.',
  },
  {
    icon: <FiLock />,
    title: 'Encrypted vault',
    text: 'All credentials and sensitive data are encrypted at rest and in transit using industry-standard encryption.',
  },
  {
    icon: <FiShare2 />,
    title: 'Secure document sharing',
    text: 'Share documents securely with your team and external partners—always protected and traceable.',
  },
  {
    icon: <FiClock />,
    title: 'Activity audit trails',
    text: 'Every action is logged with detailed audit trails so you can monitor, review, and stay compliant.',
  },
];

const HomeSecurity = () => (
  <section className="home-section home-security" id="security">
    <div className="home-container">
      <HomeReveal className="home-center-head">
        <HomeKicker icon={<FiLock />}>Security</HomeKicker>
        <h2 className="home-section-title">Enterprise-grade protection across every flowdo module</h2>
        <p className="home-section-sub">
          flowdo is built with role-based access and end-to-end encryption to keep your data safe, private, and always under your control.
        </p>
      </HomeReveal>
      <div className="home-security-grid">
        {PILLARS.map((pillar, index) => (
          <HomeReveal
            as="article"
            key={pillar.title}
            className="home-security-card"
            delay={index * 0.08}
          >
            <div className="home-security-icon">{pillar.icon}</div>
            <div>
              <h3>{pillar.title}</h3>
              <p>{pillar.text}</p>
            </div>
          </HomeReveal>
        ))}
      </div>
      <HomeReveal className="home-security-cta" delay={0.24}>
        <HomeBtn to="/privacy-policy">Learn More</HomeBtn>
      </HomeReveal>
    </div>
  </section>
);

export default HomeSecurity;
